module.exports = {"532301101":"鹿城镇","532301102":"东瓜镇","532301103":"吕合镇","532301104":"紫溪镇","532301105":"东华镇","532301106":"子午镇","532301107":"苍岭镇","532301108":"三街镇","532301109":"八角镇","532301110":"中山镇","532301111":"新村镇","532301112":"西舍路镇","532301201":"树苴乡","532301202":"大过口乡","532301203":"大地基乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532301.json
// module id = 2614
// module chunks = 0